module.exports = __webpack_public_path__ + "media/images/career_camp/2022/hero/col_greg-b19d69cb4f2f451b6b03471f4cfd027b.svg";